import { render, staticRenderFns } from "./NewRequestQuote.vue?vue&type=template&id=4d49bde8"
import script from "./NewRequestQuote.vue?vue&type=script&lang=js"
export * from "./NewRequestQuote.vue?vue&type=script&lang=js"
import style0 from "./NewRequestQuote.vue?vue&type=style&index=0&id=4d49bde8&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wedevs/Herd/dokan-core/wp-content/plugins/dokan-pro/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d49bde8')) {
      api.createRecord('4d49bde8', component.options)
    } else {
      api.reload('4d49bde8', component.options)
    }
    module.hot.accept("./NewRequestQuote.vue?vue&type=template&id=4d49bde8", function () {
      api.rerender('4d49bde8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "modules/request-for-quotation/assets/src/js/admin/pages/NewRequestQuote.vue"
export default component.exports